<template>
  <BlockLoading v-if="isPending" class="site-navigation-loader" />

  <BlockError v-else-if="isError" class="site-navigation-error">
    <i class="bx bxs-error text-danger" aria-label="Error loading site navigation" />
  </BlockError>

  <GuNavbarRaw v-else :items="siteNavigation?.mainMenu" />
</template>

<script setup>
import { getNavigation } from '@shared/api/systemData.api'
import BlockError from '@shared/components/BlockError.vue'
import BlockLoading from '@shared/components/BlockLoading.vue'
import GuNavbarRaw from '@shared/gu-components/navbar/GuNavbarRaw.vue'

const {
  data: siteNavigation,
  isError,
  isPending,
} = getNavigation()
</script>
